import * as S from './style';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import conferenceImg from '@/assets/img/conferenceImg.jpeg';
import TabList from '@/components/common/Tab/TabList/TabList';
import CalenderIcon from '@/components/Icon/CalenderIcon';
import SpotIcon from '@/components/Icon/SpotIcon';
import EventInfo from '@/components/Conference/EventInfo/EventInfo';
import Program from '@/components/Conference/Program/Program';
import useIsMobile from '@/hooks/useIsMobile';
import GreenConfirm from '@/components/Conference/GreenConfirm/GreenConfirm';
import RegisterConfirm from '@/components/Conference/RegisterConfirm/RegisterConfirm';
import RegisterGuide from '@/components/Conference/RegisterGuide/RegisterGuide';
import GreenGuide from '@/components/Conference/GreenGuide/GreenGuide';
import BoxTab from '@/components/common/Tab/BoxTab/BoxTab';
import BeforeConference from '@/components/Conference/BeforeConference/BeforeConference';
import SponsorInformation from '@/components/Conference/SponsorInformation/SponsorInformation';
import { useEffect, useState } from 'react';
import { useModalStore } from '@/store/modalStore';
import { CONF_PLACE, CONF_DATE, CONF_TITLE_MAIN } from '@/constants/menu';
import ModalPortal from '@/components/common/Modal/ModalPortal/ModalPortal';
import ModalBox from '@/components/common/Modal/ModalBox/ModalBox';

import CompleteModal from '@/components/common/Modal/CompleteModal/CompleteModal';
const Conference = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const isMobile = useIsMobile(900);
	const { showModal } = useModalStore();
	const [isOpen, setIsOpen] = useState(false);
	const [searchParams] = useSearchParams();
	const params = location.state?.menu ?? '학술대회 안내';
	const depthParams = location.state?.depthMenu ?? '행사정보';
	const stepParams = location.state?.step;
	const tabList = ['학술대회 안내', '지난 학술대회'];
	const depthList = ['행사정보', '프로그램', '등록안내', '초록안내', '후원안내'];
	const sucessParams = searchParams.get('sucess') ?? '';
	const failParams = searchParams.get('aid') ?? '';

	const handleMenuName = (menu: string) => {
		navigate('/conference', { state: { menu: menu } });
	};
	const handleDepthMenuName = (depth: string) => {
		navigate('/conference', { state: { menu: params, depthMenu: depth } });
	};

	useEffect(() => {
		if (sucessParams === 'true') {
			setIsOpen(true);
		}
		if (sucessParams === 'false' || failParams !== '') {
			showModal('결제에 실패했습니다. \n다시 시도해 주세요.');
			navigate('/conference', { state: { menu: params, depthMenu: '등록안내' } });
		}
	}, [sucessParams, failParams]);

	return (
		<S.Container>
			<S.Header>
				<S.Title>{params}</S.Title>
				<S.HeaderTab>
					<TabList isNotSticky menuList={tabList} menuKey={params} onListClick={handleMenuName} />
				</S.HeaderTab>

				{params !== tabList[1] && (
					<S.HeaderContentBox>
						{!isMobile && (
							<S.ImgBox bgImg={conferenceImg}>
								<div className="title_box">
									<div className="title">
										2026년 (사)한국노인과학학술단체연합회 학술대회 & 한국노화학회 추계학술대회 <br />
										초고령사회의 새로운 패러다임: 디지털 전환과 AI 기반 혁신
									</div>
									{/* <div className="sub_title">Toward Healthy and Dignified Aging</div> */}
								</div>
							</S.ImgBox>
						)}

						<S.HeaderContent>
							<S.HeaderSubContent>
								<S.HeaderContentTitle>{CONF_TITLE_MAIN}</S.HeaderContentTitle>
								<S.HeaderSubContentItem>
									<div className="title">
										<CalenderIcon /> 학술대회 일정
									</div>
									<div className="content">{CONF_DATE}</div>
								</S.HeaderSubContentItem>
								<S.HeaderSubContentItem>
									<div className="title">
										<SpotIcon /> 학술대회 장소
									</div>
									<div className="content">{CONF_PLACE}</div>
								</S.HeaderSubContentItem>
							</S.HeaderSubContent>
						</S.HeaderContent>
						{isMobile && (
							<S.ImgBox bgImg={conferenceImg}>
								<div className="title_box">
									<div className="title">
										2026년 (사)한국노인과학학술단체연합회 학술대회 & 한국노화학회 추계학술대회 <br />
										초고령사회의 새로운 패러다임: 디지털 전환과 AI 기반 혁신
									</div>
									{/* <div className="sub_title">Toward Healthy and Dignified Aging</div> */}
								</div>
							</S.ImgBox>
						)}
					</S.HeaderContentBox>
				)}
			</S.Header>
			{params !== tabList[1] && <BoxTab menuList={depthList} menuKey={depthParams} onListClick={handleDepthMenuName} />}
			{params === tabList[0] && depthParams === depthList[0] && <EventInfo />}
			{params === tabList[0] && depthParams === depthList[1] && <Program />}
			{params === tabList[0] && depthParams === depthList[2] && stepParams === '등록 확인' && <RegisterConfirm />}
			{params === tabList[0] && depthParams === depthList[2] && stepParams !== '등록 확인' && <RegisterGuide />}
			{params === tabList[0] && depthParams === depthList[3] && stepParams === '초록 확인' && <GreenConfirm />}
			{params === tabList[0] && depthParams === depthList[3] && stepParams !== '초록 확인' && <GreenGuide />}

			{params === tabList[0] && depthParams === depthList[4] && <SponsorInformation />}
			{params === tabList[1] && <BeforeConference />}
			{isOpen && (
				<ModalPortal>
					<ModalBox onClick={() => setIsOpen(false)}>
						<CompleteModal closeModal={setIsOpen} />
					</ModalBox>
				</ModalPortal>
			)}
		</S.Container>
	);
};

export default Conference;
